import React from 'react';
import Type from 'prop-types';
import { Link, useRouteMatch, useLocation } from 'react-router-dom';
import { List, ListItem, ListItemText, ListItemIcon, Card, CardContent } from '@material-ui/core';
import { ru } from 'locale';
import { backNavigationStore } from 'stores';
import { getMainUrl } from 'utils/navigation';
import useStyles from './OtherCategories.styles';

const OtherCategories = props => {
  const classes = useStyles();
  const { role, permissionAccessCategories, categories } = props;
  const { path } = useRouteMatch();
  const location = useLocation();
  const mainUrl = getMainUrl(path);
  backNavigationStore.setBackUrl(location.pathname);

  return (
    <Card square>
      <CardContent classes={{ root: classes.cardContent }}>
        <List component="nav" aria-label={ru.otherCategories}>
          {categories.map(category => {
            if (role === 'guest' && permissionAccessCategories.includes(category.id)) {
              return null;
            }

            const Icon = category.icon;

            return (
              <ListItem
                key={category.id}
                id={category.id}
                button
                component={Link}
                to={`${mainUrl}${category.id}`}
              >
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={category.label} />
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

OtherCategories.propTypes = {
  categories: Type.arrayOf(
    Type.shape({
      id: Type.string.isRequired,
      label: Type.oneOfType([Type.string, Type.node]),
      icon: Type.elementType.isRequired,
    }),
  ).isRequired,
  role: Type.oneOf(['admin', 'maintainer', 'guest']).isRequired,
  permissionAccessCategories: Type.arrayOf(Type.string),
};

OtherCategories.defaultProps = {
  permissionAccessCategories: [],
};

export default OtherCategories;
